<template>
  <mj-modal-wrapper>
    <mj-modal-head>
      <h2 class="font-semibold text-white text-2xl">
        Passwort ändern
      </h2>
    </mj-modal-head>

    <mj-modal-content>
      <mj-validation-observer
        id="profile-change-password"
        v-slot="{ invalid }"
        ref="formObserver"
        tag="form"
        method="post"
        @submit.prevent="onSubmit"
      >
        <div class="profile-change-password-modal__inputs">
          <mj-input-group>
            <mj-input-label
              for="password"
              class="text-lg text-gray-900"
            >
              Aktuelles Passwort
            </mj-input-label>
            <mj-validation-input-field
              v-model="passwordForm.password"
              name="password"
              type="password"
              rules="required"
              placeholder="Dein aktuelles Passwort"
              autocomplete="off"
            />
          </mj-input-group>

          <mj-input-group>
            <mj-input-label
              for="new_password"
              class="text-lg text-gray-900"
            >
              Neues Passwort
            </mj-input-label>
            <mj-validation-input-field
              v-model="passwordForm.new_password"
              name="new_password"
              type="password"
              placeholder="Dein neues Passwort"
              autocomplete="off"
              rules="required|min:6"
            />
          </mj-input-group>

          <mj-input-group>
            <mj-input-label
              for="new_password_confirmation"
              class="text-lg text-gray-900"
            >
              Neues Passwort wiederholen
            </mj-input-label>
            <mj-validation-input-field
              v-model="passwordForm.new_password_confirmation"
              name="new_password_confirmation"
              type="password"
              placeholder="Dein neues Passwort wiederholen"
              autocomplete="off"
              rules="required|confirmed:new_password"
            />
          </mj-input-group>
        </div>
        <div class="profile-change-password-modal__buttons flex justify-between mt-12">
          <div class="close">
            <mj-button
              class="btn-naked"
              @click="onClose"
            >
              Abbrechen
            </mj-button>
          </div>
          <div class="submit">
            <mj-button
              class="btn-primary inline-flex"
              :is-busy="isBusy"
              :disabled="invalid"
              type="submit"
              @click="onSubmit"
            >
              Speichern
            </mj-button>
          </div>
        </div>
      </mj-validation-observer>
    </mj-modal-content>
  </mj-modal-wrapper>
</template>

<script>
import { mapActions } from 'vuex';
import ModalWrapper from '@/components/ui/general/modal/ModalWrapper.vue';
import ModalHead from '@/components/ui/general/modal/ModalHead.vue';
import ModalContent from '@/components/ui/general/modal/ModalContent.vue';

export default {

  name: 'ProfileChangePasswordModal',

  components: {
    'mj-modal-wrapper': ModalWrapper,
    'mj-modal-head': ModalHead,
    'mj-modal-content': ModalContent,
  },

  props: {
    params: {
      type: Object,
      required: false,
      default: () => {},
    },
  },

  data() {
    return {
      passwordForm: {
        password: '',
        new_password: '',
        new_password_confirmation: '',
      },
      isBusy: false,
    };
  },

  methods: {
    ...mapActions(['updateUser']),

    async onSubmit() {
      if (await this.$refs.formObserver.validate()) {
        this.isBusy = true;
        this.updateUser(this.passwordForm)
          .then(() => {
            this.onClose();
          })
          .catch(({ response }) => {
            this.$refs.formObserver.setErrors(response.data.errors);
          })
          .finally(() => { this.isBusy = false; });
      }
    },

    onClose() {
      this.passwordForm = {
        password: '',
        new_password: '',
        new_password_confirmation: '',
      };
      this.$modal.hide('root-modal');
    },
  },
};
</script>
